import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import moment from 'moment';
import styled from 'styled-components';

const TIMESLOTS_AVAILABLE_QUERY = gql`
  query appointmentsAvailable(
    $appointmentTypeId: Int!
    $labId: Int
    $locationId: Int
    $startDateTime: String!
  ) {
    hasTimeSlots(
      appointmentTypeId: $appointmentTypeId
      labId: $labId
      locationId: $locationId
      startDateTime: $startDateTime
    )
  }
`;
interface TimeSlotsAvailableQueryResponse {
  hasTimeSlots: boolean;
}

const FallbackMessage = styled.div`
  text-align: center;
  font-size: 28px;
  color: ${props => props.theme.colors.KBNight};
  padding-top: 50px;
`;

const DEFAULT_FALLBACK = (
  <FallbackMessage>There are no available time slots for this appointment.</FallbackMessage>
);

interface Props {
  appointmentTypeId: number | null;
  locationId: number | null;
  labId: number | null;
  fallback?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Renders children if the provided location has bookable appointment slots, renders fallback component if the location has no bookable appointments.
 **/
export const WhenAppointmentsAvailable = ({
  appointmentTypeId,
  locationId,
  labId,
  fallback,
  children
}: Props) => {
  const fallbackComponent: React.ReactNode = fallback ?? DEFAULT_FALLBACK;

  const { data, loading } = useQuery<TimeSlotsAvailableQueryResponse>(TIMESLOTS_AVAILABLE_QUERY, {
    variables: {
      appointmentTypeId: appointmentTypeId,
      locationId: locationId ? locationId : null,
      labId: labId,
      startDateTime: moment.utc().startOf('month')
    }
  });

  if (loading) return null;

  if (!data?.hasTimeSlots) return <>{fallbackComponent}</>;

  return <>{children}</>;
};
